import type {Execution} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {ManifestActionValue} from './types'
import {ActionExecution} from './ActionExecution'
import type {DataModelAPI} from '../../../dataModel/dataModel'

export class ActionExecutionBuilder {
    private readonly actionExecution: ActionExecution

    constructor(dataModelAPI: DataModelAPI) {
        this.actionExecution = new ActionExecution(dataModelAPI)
    }
    public build = (value: ManifestActionValue) => {
        const displayName = 'label' in value ? value.label.value : undefined
        const execution = this.createExecution(value)

        return {execution, displayName}
    }

    private getActionExecutionWhenIdExists = (actionId: string): Execution | undefined => {
        if (actionId.includes('open-dashboard')) {
            const dashboardId = this.extractDashboardId(actionId)
            if (!dashboardId) throw new Error(`Dashboard ID not found in actionId: ${actionId}`)
            return this.actionExecution.getDashboardPanelExecutor(dashboardId)
        }

        if (actionId.includes('open-blocks-panel')) {
            const blocksPanelId = this.extractBlocksPanelId(actionId)
            if (!blocksPanelId) throw new Error(`Blocks Panel ID not found in actionId: ${actionId}`)
            return this.actionExecution.getCustomPanelExecutor(blocksPanelId)
        }

        // Forward action cases
        return this.actionExecution.createFields(actionId)
    }

    private createExecution = (value: ManifestActionValue): Execution | undefined => {
        if ('actionId' in value) {
            if (!value.actionId) throw new Error('Action ID is required for execution')
            return this.getActionExecutionWhenIdExists(value.actionId)
        }
        if ('actionType' in value) {
            if (!value.actionType) throw new Error('Action Type is required for execution')
            return this.actionExecution.createFields(value.actionType)
        }
    }

    private extractDashboardId = (actionId: string): string | undefined => {
        // Extract id from "open-dashboard<#dashboardPageId>" format
        return actionId.match(/<#([^>]+)>/)?.[1]
    }

    private extractBlocksPanelId = (actionId: string): string | undefined => {
        // Extract id from "open-blocks-panel<panelId>" format
        return actionId.match(/<([^>]+)>/)?.[1]
    }
}
